//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    blok: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    maxWidth() {
      if ( !this.blok.max_width || this.$mq === 'sm' || this.$mq === 'md') {
        return '100%'
      } else {
        return this.blok.max_width + 'px'
      }
    }
  }
}
